import React from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import MidBox from "./Boxes/MidBox";
import Button from "./Button";
import CircularProgress from "./CircularProgress";
import classNames from "classnames";
import { useAppTranslation } from "../i18n/useAppTranslation";
export type DialogProps = {
  open: boolean;
  title?: React.ReactNode;
  noTitle?: boolean;
  className?: string;
  dialogClassName?: string;
  noFooter?: boolean;
  noHeader?: boolean;
  loading?: boolean;
  force?: boolean;
  layoutLoading?: boolean;
  backdropClose?: boolean;
  submitStyle?: React.CSSProperties;
  onClose?: () => void;
  children: React.ReactNode;
  onSubmit?: React.EventHandler;
  closeLabel?: React.ReactNode;
  submitLabel?: React.ReactNode;
  submitVariant?: string;
  disableSubmit?: boolean;
  size?: "sm" | "lg" | "xl";
  style?: React.CSSProperties;
};

const Dialog = ({
  open,
  title,
  noTitle = false,
  onClose,
  submitStyle,
  submitVariant,
  disableSubmit,
  force,
  size,
  className,
  dialogClassName,
  noFooter,
  loading,
  layoutLoading,
  children,
  onSubmit,
  closeLabel,
  submitLabel,
  style,
  backdropClose,
  noHeader,
}: DialogProps) => {
  const { t } = useAppTranslation("common");

  return (
    <Modal
      dialogClassName={dialogClassName}
      aria-label={typeof title === "string" ? title : undefined}
      size={size || undefined}
      show={open}
      onHide={onClose}
      backdrop={backdropClose ? true : "static"}
      keyboard={false}
      contentClassName={"bg-transparent border-0"}
      centered
      style={{ background: "transparent", ...style }}
    >
      {layoutLoading && (
        <CircularProgress
          style={{
            position: "absolute",
            right: 0,
            zIndex: 100,
            width: 50,
            height: 50,
            top: "45%",
            left: 0,
            marginInline: "auto",
          }}
        />
      )}
      <MidBox
        noTitle={noHeader}
        style={{
          transition: "0.4s all",
          filter: layoutLoading ? "blur(6px)" : "",
        }}
        modal
        title={title || ""}
        className={classNames(className, {})}
      >
        {!force && (
          <button
            aria-label={t("actions.close")}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose?.();
            }}
            className="button btn-close"
          ></button>
        )}
        {children}

        {!noFooter && (
          <>
            <br />
            <br />
            <div
              style={{
                position: "absolute",
                bottom: 33,
                right: 0,
                width: "100%",
              }}
              className="d-flex mt-4  justify-content-center"
            >
              {onSubmit && (
                <Button
                  disabled={disableSubmit}
                  style={submitStyle}
                  className="me-2"
                  loading={loading}
                  onClick={onSubmit}
                  variant={submitVariant! || "primary"}
                >
                  {submitLabel || t("actions.submit")}
                </Button>
              )}
              <Button onClick={onClose} variant="default">
                {closeLabel || t("actions.close")}
              </Button>
            </div>
          </>
        )}
      </MidBox>
    </Modal>
  );
};

export default Dialog;
